import { Component, Input, OnInit } from '@angular/core';
import { InfoTextService, InfoText, InfoTextModel, InfoTextTranslationModel } from 'src/app/core/services/api-services';
import { LanguageService } from 'src/app/core/services/language.service';
import { BaseComponent } from 'src/app/core/components/base.component';
import { InfoIconDialogComponent } from '../../containers/info-icon-dialog/info-icon-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
    selector: 'app-info-icon',
    templateUrl: './info-icon.component.html',
    styleUrls: ['./info-icon.component.scss'],
    standalone: false
})

export class InfoIconComponent extends BaseComponent implements OnInit {
  @Input() key!: InfoText;
  @Input() color: string = 'primary';
  protected infoText: InfoTextModel | null = null;
  protected infoTextTranslation: InfoTextTranslationModel | null = null;

  constructor(
    private readonly infoTextService: InfoTextService,
    private readonly languageService: LanguageService,
    private readonly matDialog: MatDialog,
    private readonly breakpointObserver: BreakpointObserver
  ) {
    super();
  }

  ngOnInit(): void {
    this.languageService.currentLanguageCode$
      .unsubscribeOnDestroy(this)
      .subscribe(language => {
        if (this.key) {
          this.infoTextService.get(this.key, language)
            .subscribe(model => {
              this.infoText = model;
              this.infoTextTranslation = model.translations[0];
            });
        }
      });
  }

  protected openDialog(): void {
    InfoIconDialogComponent.open(this, this.matDialog, this.breakpointObserver, this.infoTextTranslation!)
  }
}
